/*
 *             Copyright (c) 2016 - 2023, CKSource Holding sp. z o.o. All rights reserved.
 *
 *
 *
 *
 *          +---------------------------------------------------------------------------------+
 *          |                                                                                 |
 *          |                                 Hello stranger!                                 |
 *          |                                                                                 |
 *          |                                                                                 |
 *          |   What you're currently looking at is the source code of a legally protected,   |
 *          |    proprietary software. Any attempts to deobfuscate / disassemble this code    |
 *          |               are forbidden and will result in legal consequences.              |
 *          |                                                                                 |
 *          |                                                                                 |
 *          +---------------------------------------------------------------------------------+
 *
 *
 *
 *
 */
const _0xae22=['newRange','oldRange','decompress'];(function(_0x5165e4,_0xae2253){const _0x52fe5c=function(_0x6db12b){while(--_0x6db12b){_0x5165e4['push'](_0x5165e4['shift']());}};_0x52fe5c(++_0xae2253);}(_0xae22,0x1ba));const _0x52fe=function(_0x5165e4,_0xae2253){_0x5165e4=_0x5165e4-0x0;let _0x52fe5c=_0xae22[_0x5165e4];return _0x52fe5c;};import _0xb1a6d6 from'./operationcompressor';export default class n extends _0xb1a6d6{[_0x52fe('0x1')](_0x5d6843,_0x153f68){super[_0x52fe('0x1')](_0x5d6843,_0x153f68);const _0xe7ca3e=_0x5d6843[_0x5d6843['length']-0x1];_0xe7ca3e[_0x52fe('0x0')]||(_0xe7ca3e[_0x52fe('0x0')]=null),_0xe7ca3e['newRange']||(_0xe7ca3e[_0x52fe('0x2')]=null);}}